import { useLayoutEffect, useState } from "react"

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0])

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener("resize", updateSize)
    updateSize()
    return () => window.removeEventListener("resize", updateSize)
  }, [])

  return size
}

export const useInMobileView = () => {
  const [width] = useWindowSize()
  return width > 0 && width <= 640
}

export const useInTabletView = () => {
  const [width] = useWindowSize()
  return width > 0 && width <= 1024
}
